<template>
  <div class="location-val-selector">
    <div class="row">
      <div v-if="setting.location" class="location-wrapper">
        <span v-tip>{{ setting.location.poiName + " " + setting.location.address }}</span>
        <el-button type="text" @click="setting.location = null">清空</el-button>
      </div>
      <template v-else>
        <tree-select :group-list="vars" v-model="setting.value" size="small"></tree-select>
        <el-button type="text" @click="selectLocation">选择定位</el-button>
      </template>
    </div>
    <normal-select
      v-if="setting.type === 'area'"
      class="area-level"
      :select-list="addressLevel"
      :selected-item.sync="setting.level"
    ></normal-select>
    <location-dialog
      ref="locationDialog"
      :value="setting.location"
      @input="updateLocation"
    ></location-dialog>
  </div>
</template>

<script>
import TreeSelect from "@/components/UIComponents/TreeSelect.vue"
import NormalSelect from "@/components/UIComponents/NormalSelect.vue"
import LocationDialog from "@/components/UIComponents/LocationDialog.vue"

export default {
  name: "location-val-selector",
  components: {
    TreeSelect,
    NormalSelect,
    LocationDialog
  },
  props: {
    canUseVars: Array,
    setting: {
      type: Object
      // default: () => ({
      //   type: null, // area, location, const:固定定位
      //   value: "", // 控件ID（type是area, location时）/ const: vCurrentLocation
      //   location: {}, // 定位对象（type是const时有值）
      //   level: 3 // 政府等级（type是area时有值）
      // })
    }
  },
  computed: {
    vars() {
      return (this.canUseVars || []).concat({
        label: "系统",
        options: [
          {
            label: "[系统] 当前定位",
            type: "location",
            value: "vCurrentLocation"
          }
        ]
      })
    },
    optionMap() {
      return this._.keyBy(
        this.vars.flatMap(t => t.options),
        "value"
      )
    }
  },
  watch: {
    "setting.value": function() {
      if (this.setting.value === null) {
        this.$set(this.setting, "type", "const")
        this.setting.level = null
        return
      }
      let option = this.optionMap[this.setting.value]
      let type = option?.type
      this.$set(this.setting, "type", type)
      if (type !== "area") {
        this.setting.level = null
      }
    }
  },
  data() {
    return {
      addressLevel: [
        {
          label: "省政府",
          value: 1
        },
        {
          label: "市政府",
          value: 2
        },
        {
          label: "区政府",
          value: 3
        },
        {
          label: "街道政府",
          value: 4
        }
      ]
    }
  },
  methods: {
    selectLocation() {
      this.setting.value = null
      if (!this.setting.location) {
        this.$set(this.setting, "location", {})
      }
      this.$refs.locationDialog.open()
    },
    updateLocation(location) {
      this.$set(this.setting, "location", this._.omit(location, "detail"))
    }
  }
}
</script>

<style lang="scss" scoped>
.location-val-selector {
  .row {
    display: flex;
    align-items: center;
    .tree-select {
      flex: 1;
    }
    .location-wrapper {
      display: flex;
      overflow: hidden;
    }
  }
  .area-level {
    margin-top: 10px;
  }
}
</style>
